export const PageText = {
  "_1": "Prijs",
  "_2": "Probeer aircheckr met ons kosteloos 'free' abonnement of start onmiddellijk met de 'basic' of 'enterprise' opties."
};

export const Categories = {
  "_1": {
    "title": "Kies een abonnement",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Neem zelf de proef op de som",
        "text": "Probeer aircheckr uit via ons gratis abonnement en leer in detail wat aircheckr voor jou kan betekenen. Het is zonder enige verplichting en het heeft geen einddatum. Aarzel niet om <a href=\"/contact\">ons te contacteren</a> indien je je abonnement wilt upgraden. We helpen je ook graag verder met uw specifieke vragen over luchtkwaliteit of met de effectieve integratie van aircheckr in je product of testcase."
      }
    ]
  },
  "_2": {
    "title": "Waarom kost aircheckr wat het kost?",
    "subcategories": [
        {
        "key": 0,
        "subtitle": "Luchtkwaliteit is belangrijk",
        "text": "Luchtkwaliteit is hot. Veel mensen zijn bezorgd, maar voelen zich hulpeloos om gepast te handelen. aircheckr verandert luchtkwaliteit in iets positiefs. Mensen zijn niet langer weerloos. aircheckr stelt je klanten in staat om actief of passief betere beslissingen te nemen en zo betere lucht in te ademen."
      },
      {
        "key": 1,
        "subtitle": "De best beschikbare luchtkwaliteitsgegevens",
        "text": "Luchtvervuiling naast een snelweg tijdens spitsuur kan aanzienlijk verschillen van die in het park op 200 meter afstand (zie voorbeeld in onderstaande figuur). Lange tijd waren er geen real-time gegevens beschikbaar om deze verschillen te weerspiegelen. aircheckr verandert dit volledig met zijn real-time en gedetailleerde informatie over de buitenluchtkwaliteit.",
        "text_2": "aircheckr is gedetailleerd, snel, eenvoudig te interpreteren, van hoge kwaliteit en toegepast, waardoor een enorme hoeveelheid mogelijkheden voor dagelijks gebruik door individuen en integratie in bedrijven wordt geopend."
      }
    ]
  }
};

export const PriceOptions = {
  "_1": {
    "type": "free",
    "header": {
      "icon": "leaf",
      "title": "Free",
      "meta": "voor niet-commercieel gebruik"
    },
    "body": {
      "price": {
        "amount": "0",
        "currency": "euro",
        "after": "altijd"
      },
      "features": [
        {
          "text": "geen verplichtingen"
        },
        {
          "text": "tot 1.500",
          "meta": "API calls/maand"
        },
        {
          "text": "email support"
        }
      ],
      "cta": {
        "text": "Registreer",
        "linkAddress": "/signup",
        "type": "soft"
      }
    }
  },
  "_2": {
    "type": "pro",
    "header": {
      "icon": "tree",
      "title": "Pro",
      "meta": "voor commercieel gebruik"
    },
    "body": {
      "price": "Contacteer<br/>Ons",
      "features": [
        {
          "text": "aangepaste oplossing"
        },
        {
          "text": "ongelimiteerd",
          "meta": "incl. statistieken"
        },
        {
          "text": "support & inzichten"
        }
      ],
      "cta": {
        "text": "Neem contact op",
        "linkAddress": "/contact",
        "type": "primary"
      }
    }
  },
  "_3": {
    "type": "research",
    "header": {
      "icon": "university",
      "title": "Onderzoek",
      "meta": "voor ons nageslacht"
    },
    "body": {
      "price": "Contacteer<br/>Ons",
      "features": [
        {
          "text": "geschikt voor studies"
        },
        {
          "text": "ongelimiteerd",
          "meta": "incl. statistieken"
        },
        {
          "text": "support & inzichten"
        }
      ],
      "cta": {
        "text": "Neem contact op",
        "linkAddress": "/contact",
        "type": "primary-light"
      }
    }
  },
  "footnotes": {
    "text_1": "<strong>O&O</strong>: Als je aircheckr uitsluitend voor Onderzoek en Ontwikkeling wenst te gebruiken of als input voor een publicatie of artikel, <a href=\"/contact\">contacteer ons</a> dan voor een aangepaste licentie."
  }
}

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/nl/pricing_page.js